import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { pfpt } from 'packs/styles/fontawesome/custom_icons'
import { faUserSecret } from '@fortawesome/free-solid-svg-icons'

import Icon from 'components/dr_icon'

library.add( fab, pfpt, faUserSecret )


class FAIcon extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        const icon_name = this.props.icon_name
        const icon_prefix = this.props.prefix || 'fab'
        const class_name = this.props.icon_name || ''
        return <FontAwesomeIcon icon={[icon_prefix, icon_name]} className={'fa '+ class_name}/>
    }
}

const FADefaultIcons = {
    ENTITY:{

    },
    PROPERTY: {
        BE: { name: 'BrandEntity', icon: <Icon name={'loyalty'} className={'fa-align'}/>},
        FB: { name: 'Facebook', icon: <FAIcon icon_name={'facebook-square'}/>},
        FR: { name: 'Flickr', icon: <FAIcon icon_name={'flickr'}/>},
        GP: { name: 'GooglePlus', icon: <FAIcon icon_name={'google-plus'}/>},
        HS: { name: 'Hootsuite', icon: <b>???</b>},
        IG: { name: 'Instagram', icon: <FAIcon icon_name={'instagram'}/>},
        LI: { name: 'LinkedIn', icon: <FAIcon icon_name={'linkedin'}/>},
        MT: { name: 'Microsoft Teams', icon: <b>???</b>}, //<FAIcon icon_name={'ms-teams'}/>}
        PI: { name: 'Pinterest', icon: <FAIcon icon_name={'pinterest'}/>},
        PP: { name: 'PeopleProtect', icon: <FAIcon icon_name={'user-secret'} prefix={'fas'}/> },
        PP_5000: { name: 'PeopleProtect - Person Protect Account', icon: <Icon name={'account_box'}  className={'fa-align'}/> },
        PP_5150: { name: 'PeopleProtect - DarkOwl Search Result', icon: <FAIcon icon_name={'user-secret'} prefix={'fas'}/> },
        PP_5001: { name: 'PeopleProtect - Place Account', icon: <Icon name={'place'}  className={'fa-align'}/> },
        PS: { name: 'Periscope', icon: <FAIcon icon_name={'periscope'}/>},
        RN: { name: 'Renren', icon: <FAIcon icon_name={'renren'}/>},
        SF: { name: 'Salesforce Chatter', icon: <FAIcon icon_name={'salesforce'}/>},
        SL: { name: 'Slack', icon: <FAIcon icon_name={'slack'}/>},
        SS: { name: 'SlideShare', icon: <FAIcon icon_name={'slideshare'}/>},
        TQ: { name: 'Tencent Weibo', icon: <FAIcon icon_name={'tencent-weibo'}/>},
        TR: { name: 'Tumblr', icon: <FAIcon icon_name={'tumblr'}/>},
        TW: { name: 'Twitter', icon: <FAIcon icon_name={'twitter'}/>},
        VI: { name: 'Vine', icon: <FAIcon icon_name={'vine'}/>},
        VK: { name: 'VKontakte',  icon: <b>???</b>},
        VM: { name: 'Vimeo', icon: <FAIcon icon_name={'vimeo'}/>},
        WE: { name: 'Sina Weibo', icon: <FAIcon icon_name={'weibo'}/>},
        WP: { name: 'Wordpress', icon: <FAIcon icon_name={'wordpress'}/>},
        WS: { name: 'Website', icon: <b>???</b> },
        YP: { name: 'Yelp', icon: <FAIcon icon_name={'yelp'}/>},
        YT: { name: 'YouTube', icon: <FAIcon icon_name={'youtube'}/>},
        YX: { name: 'Yext', icon: <b>???</b> },
        ZM: { name: 'Zoom', icon: <FAIcon icon_name={'zoom'} prefix={'pfpt'}/>},
        unknown: { name: 'unknown', icon: '' }
    },
    CONFIG: {
        PATROL_CONFIG: { name: 'Patrol Config', icon: <FAIcon icon_name={'patrol-config'} prefix={'pfpt'} fill={'#fff'}/>},
    }
}

export  {FAIcon, FADefaultIcons}


